import { render, staticRenderFns } from "./EdgeRequest.vue?vue&type=template&id=2e2390d2&scoped=true"
import script from "./EdgeRequest.vue?vue&type=script&lang=js"
export * from "./EdgeRequest.vue?vue&type=script&lang=js"
import style0 from "./EdgeRequest.vue?vue&type=style&index=0&id=2e2390d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2390d2",
  null
  
)

export default component.exports